export const MagicpotEventsListing = (state) => {
    return state?.magicpotevents?.magicpotevents;
};

export const MagicpotIsLoading = (state) => {
    return state?.magicpotevents?.showLoading;
};

export const MagicPotDonationList = (state) => {
    return state?.magicpotevents?.magicpotdonationlist;
};